"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmeltingPlantRebalanced = void 0;
var Tags_1 = require("../../Tags");
var PreludeCard_1 = require("../../prelude/PreludeCard");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var SmeltingPlantRebalanced = (function (_super) {
    __extends(SmeltingPlantRebalanced, _super);
    function SmeltingPlantRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.SMELTING_PLANT_REBALANCED,
            tags: [Tags_1.Tags.BUILDING],
            metadata: {
                cardNumber: 'P30',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.oxygen(2).br;
                    b.steel(4).br;
                    b.effect(undefined, function (eb) {
                        eb.empty().startAction.cards(1).secondaryTag(Tags_1.Tags.BUILDING);
                    });
                }),
                description: 'Raise oxygen 2 steps. Gain 4 steel. Draw 1 building card.',
            },
        }) || this;
    }
    SmeltingPlantRebalanced.prototype.play = function (player) {
        player.steel += 4;
        player.game.increaseOxygenLevel(player, 2);
        player.drawCard(1, { tag: Tags_1.Tags.BUILDING });
        return undefined;
    };
    return SmeltingPlantRebalanced;
}(PreludeCard_1.PreludeCard));
exports.SmeltingPlantRebalanced = SmeltingPlantRebalanced;
//# sourceMappingURL=SmeltingPlantRebalanced.js.map